
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Result from "../pages/result/page";
import ErrorPage from "../pages/error/page";
import LegalPage from "../pages/legal/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/result",
    element: <Result />,
  },
  {
    path: "/error",
    element: <ErrorPage />,
  },
  {
    path: "/legal",
    element: <LegalPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
